import Head from 'next/head';

export interface ItemListSoftware {
  name: string;
  /** Absolute URL of the product (vendor site or Kreatli page). */
  url: string;
}

interface Props {
  /** List title, e.g. the page H1. */
  name: string;
  /** Absolute URL of the page that holds the list. */
  url: string;
  items: ItemListSoftware[];
}

/**
 * ItemList JSON-LD for roundup pages: one `SoftwareApplication` per listed tool, in page order.
 * Deliberately has no ratings or reviews (no `aggregateRating`): we don't publish scores we can't back up.
 */
export function ItemListStructuredData({ name, url, items }: Props) {
  if (items.length === 0) {
    return null;
  }

  const data = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name,
    url,
    numberOfItems: items.length,
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'SoftwareApplication',
        name: item.name,
        url: item.url,
        applicationCategory: 'BusinessApplication',
        operatingSystem: 'Web',
      },
    })),
  };

  return (
    <Head>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
    </Head>
  );
}
